"use client"

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

// Sends a GA4 event to every configured property (GA only loads on production hosts, so previews/localhost send nothing)
export const track = (event: string, properties?: Record<string, unknown>) => {
  if (typeof window !== 'undefined') {
    window.gtag?.('event', event, properties)
  }
}
